import styled from "styled-components";
import { color } from "metabase/lib/colors";

export const PremiumEmbeddingLinkWidgetRoot = styled.div`
  color: ${color("text-medium")};
  padding-top: 1rem;
  width: 100%;
  max-width: 38.75rem;
  border-top: 1px solid ${color("border")};
`;
